import forms from './forms/forms.subscriptions';
import { StateType } from './store.types';

const subscriptions = (model: StateType) => ({
  ...forms(model),
});

export default subscriptions;
